import AidStudioDetails from 'containers/admin/clients/client/tabs-components/aid-studio-tab/aid-studio-details';

import { useCurrentUser } from 'hooks/api/use-current-user';

import { Loader } from 'ui/loader';

const AidStudioDetailsWrapper = () => {
  const currentUser = useCurrentUser();
  const clientId = currentUser?.data?.client?.id;

  if (currentUser?.loading) {
    return <Loader loading />;
  }

  if (!clientId) {
    return null;
  }

  return <AidStudioDetails isUserView clientId={clientId} />;
};

export default AidStudioDetailsWrapper;
